<template>
    <div>
        <div class="container-fluid mt-2 mb-5">
            <div class="row">
                <!-- Added patient details section -->
                <div class="col-md-12 mt-2">
                    <div class="row">
                        <div class="col-md-8">
                            <p>
                                <strong class="fw-bold">Nombre:</strong> {{ paciente?.nombre || 'No aplica' }} |
                                <strong class="fw-bold">Fecha de Nacimiento:</strong> {{ paciente?.fecha_nacimiento ?
                                formatDate(paciente.fecha_nacimiento) : 'No aplica' }} |
                                <strong class="fw-bold">Edad:</strong> {{ paciente?.fecha_nacimiento ?
                                calculateAge(paciente.fecha_nacimiento) : 'No calculada' }} <br>
                                <strong class="fw-bold">Género:</strong> {{ paciente?.genero || 'No aplica' }}
                                <strong class="fw-bold">Teléfono:</strong> {{ paciente?.telefono || 'No aplica' }} |
                                <strong class="fw-bold">Email:</strong> {{ paciente?.email || 'No aplica' }} |
                                <strong class="fw-bold">Dirección:</strong> {{ paciente?.direccion || 'No aplica' }} <br>
                                <strong class="fw-bold">Tiene Seguridad Social:</strong> {{ paciente?.tiene_seguridad_social ? 'Sí' : 'No' }} |
                                <strong class="fw-bold">Institución de Salud:</strong> {{ paciente?.institucion_salud || 'No aplica' }}
                            </p>
                        </div>
                        <div class="col-md-4 text-end">
                            <p>
                                <strong class="fw-bold">Fecha de consulta:</strong> {{ new
                                Date().toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric'
                                }) }}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- Existing form section -->
                <div class="col-md-12  mb-3">
                    <div class="card">
                        <div class="card-body">
                            <p class="text-muted mt-2">Los campos marcados con <span class="text-danger">*</span> son
                                obligatorios.</p>
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <label class="form-label">Motivo de la Consulta <span
                                                class="text-danger">*</span></label>
                                        <textarea class="form-control" v-model.trim="nuevaConsulta.motivo"
                                            maxlength="250" required></textarea>
                                    </div>
                                    <div class="col-md-12 mb-3">
                                        <label class="form-label">Tipo de Consulta <span class="text-danger">*</span></label>
                                        <select class="form-control" v-model="nuevaConsulta.tipo_consulta" required>
                                            <option value="en consultorio">En consultorio</option>
                                            <option value="a domicilio">A domicilio</option>
                                            <option value="a hospital">A hospital</option>
                                            <option value="virtual">Virtual</option>
                                            <option value="otra">Otra</option>
                                        </select>
                                    </div>
                                    <div  class="col-md-12 mb-3">
                                        <label class="form-label">Diagnóstico <span class="text-danger">*</span></label>
                                        <textarea class="form-control" rows="5" maxlength="1000"
                                            v-model.trim="nuevaConsulta.diagnostico"></textarea>
                                    </div>
                                    <div  class="col-md-12 mb-3">
                                        <label class="form-label">Pronóstico <span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" maxlength="250" v-model.trim="nuevaConsulta.pronostico">
                                    </div>
                                    <hr  class="mt-3"/>
                                    <h4 >Signos vitales</h4>
                                    <div class="row">
                                        <div class="col-md-4 mb-3">
                                            <label class="form-label">Presión Arterial</label>
                                            <input type="text" class="form-control" v-model.trim="signosVitales.presion_arterial" />
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <label class="form-label">Temperatura (°C)</label>
                                            <input type="number" class="form-control" v-model.number="signosVitales.temperatura" />
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <label class="form-label">Frecuencia Cardíaca (lpm)</label>
                                            <input type="number" class="form-control" v-model.number="signosVitales.frecuencia_cardiaca" />
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <label class="form-label">Frecuencia Respiratoria (rpm)</label>
                                            <input type="number" class="form-control" v-model.number="signosVitales.frecuencia_respiratoria" />
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <label class="form-label">Peso (kg)</label>
                                            <input type="number" class="form-control" v-model.number="signosVitales.peso" />
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <label class="form-label">Estatura (m)</label>
                                            <input type="number" class="form-control" v-model.number="signosVitales.estatura" />
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <label class="form-label">IMC</label>
                                            <input type="number" class="form-control" v-model.number="signosVitales.imc" />
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <label class="form-label">Saturación de Oxígeno (%)</label>
                                            <input type="number" class="form-control" v-model.number="signosVitales.saturacion_oxigeno" />
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <label class="form-label">Glucosa (mg/dL)</label>
                                            <input type="number" class="form-control" v-model.number="signosVitales.glucosa" />
                                        </div>
                                    </div>
                                    <hr  class="mt-3"/>
                                    <h4 >Plan de tratamiento</h4>
                                    <div  class="row">
                                        <div class="col-md-12 mb-3">
                                            <label class="form-label">Recomendaciones generales sobre el tratamiento, aqui puedes solicitar estudios a laboratorios para el paciente.</label>
                                            <textarea class="form-control" rows="5" maxlength="1000"
                                            v-model.trim="nuevaConsulta.plan_tratamiento"></textarea>
                                        </div>
                                        <div class="col-md-8">
                                            <search-medicamentos :main-id="currentUser?.mainId" @notify="notify" @select="handleMedicamentoSelected" />
                                        </div>
                                        <div class="col-md-4 d-flex align-items-center justify-content-end">
                                            <a class="smallText text-center" @click="agregarMedicamentoManual"
                                            href="#">➕ Agregar medicamento manualmente</a>
                                        </div>
                                    </div>
                                    <div  v-for="(medicamento, index) in medicamentosRecetados" :key="index" class="mt-3">
                                        <div class="row">
                                            <div class="col-md-4 mb-3">
                                                <label class="form-label">Medicamento</label>
                                                <input type="text" class="form-control" v-model="medicamento.medicamento" />
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label class="form-label">Dosis</label>
                                                <input type="text" class="form-control" v-model="medicamento.dosis" />
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label class="form-label">Frecuencia</label>
                                                <input type="text" class="form-control" v-model="medicamento.frecuencia" />
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label class="form-label">Duración</label>
                                                <input type="text" class="form-control" v-model="medicamento.duracion" />
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label class="form-label">Observaciones</label>
                                                <input type="text" class="form-control" v-model="medicamento.observaciones" />
                                            </div>
                                            <div class="col-md-4 mb-3 text-end">
                                               <a class="smallText text-center" @click="eliminarMedicamento(index)"
                                            href="#">❌ Eliminar</a>
                                            </div>
                                        </div>
                                        <hr />
                                    </div>
                                    <hr class="mt-3"/>

                                    <div class="col-md-12 text-center">
                                        <vs-button type="submit" color="rgb(59,222,200)" gradient block @click="crearConsulta">
                                            💾 Guardar Consulta
                                        </vs-button>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import SearchMedicamentos from './SearchMedicamentos.vue';
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "Consulta",
        components: {
            SearchMedicamentos
        },
        props: {
            currentUser: {
                type: Object,
                required: true
            },
            paciente: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                nuevaConsulta: {
                    motivo:  this.paciente?.motivo, // Default value from paciente prop
                    diagnostico: '***Escribe el diagnóstico aquí***',
                    pronostico: '***Escribe el pronóstico aquí***',
                    plan_tratamiento: '***Escribe el plan de tratamiento aquí***',
                    tipo_consulta: 'en consultorio' // Default value
                },
                signosVitales: {
                    presion_arterial: '0',
                    temperatura: 0,
                    frecuencia_cardiaca: 0,
                    frecuencia_respiratoria: 0,
                    peso: 0,
                    estatura: 0,
                    imc: 0,
                    saturacion_oxigeno: 0,
                    glucosa: 0
                },
                medicamentosRecetados: [] // Array to store prescribed medications
            };
        },
        methods: {
            async crearConsulta() {
                if (!this.vEmpty(this.nuevaConsulta.motivo, 'Motivo de la Consulta')) return;
                if (!this.vEmpty(this.nuevaConsulta.diagnostico, 'Diagnóstico')) return;
                if (!this.vEmpty(this.nuevaConsulta.pronostico, 'Pronóstico')) return;

                // Validate vital signs fields
                if (!this.signosVitales.presion_arterial ) {
                    this.notify('error', 'El campo "Presión Arterial" es obligatorio.');
                    return;
                }
                const vitalSignsFields = [
                    { value: this.signosVitales.temperatura, name: 'Temperatura' },
                    { value: this.signosVitales.frecuencia_cardiaca, name: 'Frecuencia Cardíaca' },
                    { value: this.signosVitales.frecuencia_respiratoria, name: 'Frecuencia Respiratoria' },
                    { value: this.signosVitales.peso, name: 'Peso' },
                    { value: this.signosVitales.estatura, name: 'Estatura' },
                    { value: this.signosVitales.saturacion_oxigeno, name: 'Saturación de Oxígeno' }
                ];

                for (const field of vitalSignsFields) {
                    console.log('Validando campo:', field.name, field.value);
                    if (field.value === null || isNaN(field.value) || field.value < 0) {
                        this.notify('error', `El campo "${field.name}" es obligatorio, debe ser un número válido y no negativo.`);
                        return;
                    }
                }

                // Validate optional fields
                const optionalFields = [
                    { value: this.signosVitales.imc, name: 'IMC' },
                    { value: this.signosVitales.glucosa, name: 'Glucosa' }
                ];

                for (const field of optionalFields) {
                    if (field.value !== null && (isNaN(field.value) || field.value < 0)) {
                        this.notify('error', `El campo "${field.name}" debe ser un número válido y no negativo.`);
                        return;
                    }
                }

                if (!this.vEmpty(this.nuevaConsulta.plan_tratamiento, 'Observaciones y/o recomendaciones')) return;


                // Validate prescribed medications
                const hasValidMedicamento = this.medicamentosRecetados.every(medicamento => {
                    if (!medicamento.medicamento || medicamento.medicamento.trim() === '') {
                        this.notify('error', 'El campo "Nombre medicamento" es obligatorio para todos los medicamentos.');
                        return false;
                    }
                    if (!medicamento.dosis || medicamento.dosis.trim() === '') {
                        this.notify('error', 'El campo "Dosis" es obligatorio para todos los medicamentos.');
                        return false;
                    }
                    if (!medicamento.frecuencia || medicamento.frecuencia.trim() === '') {
                        this.notify('error', 'El campo "Frecuencia" es obligatorio para todos los medicamentos.');
                        return false;
                    }
                    if (!medicamento.duracion || medicamento.duracion.trim() === '') {
                        this.notify('error', 'El campo "Duración" es obligatorio para todos los medicamentos.');
                        return false;
                    }
                    return true;
                });

                console.log('Medicamentos recetados:', this.medicamentosRecetados);
                if (this.medicamentosRecetados.length > 0 && !hasValidMedicamento) {
                    return;
                }

                try {
                    const consultaData = {
                        ...this.nuevaConsulta,
                        signos_vitales: this.signosVitales,
                        tratamientos: this.medicamentosRecetados,
                        paciente_id: this.paciente.id,
                        personal_medico_id: this.currentUser.mainId
                    };

                    console.log('Consulta data:', consultaData);

                    const response = await axios.post(`${API}/crear_consulta`, consultaData);

                    if (response.data.status === 'success') {
                        this.notify('success', 'Consulta creada exitosamente');
                        this.resetForm();
                        this.$emit('terminaConsulta');
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                }
            },
            handleMedicamentoSelected(medicamento) {
                // Add the selected medication to the list of prescribed medications
                this.medicamentosRecetados.push({
                    medicamento: medicamento.nombre_medicamento || '',
                    dosis: medicamento.presentacion || '',
                    frecuencia: medicamento.dosis_usual || '',
                    duracion: '',
                    observaciones: medicamento.nombre_busqueda || ''
                });
            },
            agregarMedicamentoManual() {
                // Add a new empty medication object for manual entry
                this.medicamentosRecetados.push({
                    medicamento: '',
                    dosis: '',
                    frecuencia: '',
                    duracion: '',
                    observaciones: ''
                });
            },
            eliminarMedicamento(index) {
                // Remove a medication from the list
                this.medicamentosRecetados.splice(index, 1);
            },
            resetForm() {
                this.nuevaConsulta = {
                    motivo: '',
                    diagnostico: '***Escribe el diagnóstico aquí***',
                    pronostico: '***Escribe el pronóstico aquí***',
                    plan_tratamiento: '***Escribe el plan de tratamiento aquí***',
                    tipo_consulta: 'en consultorio' // Default value
                };
                this.signosVitales = {
                    presion_arterial: '0',
                    temperatura: 0,
                    frecuencia_cardiaca: 0,
                    frecuencia_respiratoria: 0,
                    peso: 0,
                    estatura: 0,
                    imc: 0,
                    saturacion_oxigeno: 0,
                    glucosa: 0
                };
                this.medicamentosRecetados = [];
            },
            vEmpty(value, fieldName) {
                if (!value || value.trim() === '') {
                    this.notify('error', `El campo "${fieldName}" es obligatorio.`);
                    return false;
                }
                return true;
            },
            validateDecimals() {
                const decimalFields = [
                    { value: this.signosVitales.presion_arterial, name: 'Presion arterial' },
                    { value: this.signosVitales.temperatura, name: 'Temperatura' },
                    { value: this.signosVitales.peso, name: 'Peso' },
                    { value: this.signosVitales.estatura, name: 'Estatura' },
                    { value: this.signosVitales.imc, name: 'IMC' },
                    { value: this.signosVitales.saturacion_oxigeno, name: 'Saturación de Oxígeno' },
                    { value: this.signosVitales.glucosa, name: 'Glucosa' }
                ];

                for (const field of decimalFields) {
                    if (field.value !== null && isNaN(field.value)) {
                        this.notify('error', `El campo "${field.name}" debe ser un número válido.`);
                        return false;
                    }
                }
                return true;
            },
            // Added formatDate method
            formatDate(date) {
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                return new Date(date).toLocaleDateString('es-ES', options);
            },
            calculateAge(dateOfBirth) {
                if (!dateOfBirth) return 'No calculado';
                const birthDate = new Date(dateOfBirth);
                const today = new Date();
                let age = today.getFullYear() - birthDate.getFullYear();
                const monthDiff = today.getMonth() - birthDate.getMonth();
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                return `${age} años`;
            }
        }
    };
</script>

<style>
    /* Add any necessary styles here */
</style>